import config from 'config';
import type { CycleGuideCatalog, CycleGuides } from 'core/domains/content';
import { selectors as userSelectors } from 'core/use-cases/user';
import { useContentSelector } from '../selectors';
import { useCycleGuidesSelector } from 'core/use-cases/catalog/selectors';
import { ResellerAvailableCatalogs } from 'core/services/bff';
import { imgBackup } from './const';

export function useContentCycleGuide() {
  const { data } = useContentSelector('collection_catalogs');
  const cycleGuides = useCycleGuidesSelector();
  const {
    data: { resellerId },
  } = userSelectors.useUserSelector();
  const { components } = data as unknown as { components: CycleGuides };

  const domains = {
    BOTICARIO: 'boticario.com.br',
    EUAMOMAKE: 'quemdisseberenice.com.br',
    OUI: 'ouiparis.com',
    EUDORA: 'eudora.com.br',
  } as { [key: string]: string };

  /* const imgBackup = {
    BOTICARIO: '/images/mld-boticario.png',
    EUAMOMAKE: '/images/mld-euamomake.png',
    OUI: '/images/mld-oui.png',
    EUDORA: '/images/mld-eudora.png',
  }; */

  const filterCurrentCycleGuides = () => {
    if (cycleGuides.length > 0) {
      return cycleGuides.map((cycle) => {
        const found = components?.catalogs?.find((cycleGuideCatalog: CycleGuideCatalog) => {
          return cycleGuideCatalog?.brand?.toUpperCase() === cycle?.brand;
        });

        return {
          ...cycle,
          banner: found?.banner?.url || imgBackup[cycle?.brand as keyof typeof imgBackup],
        };
      }) as unknown as ResellerAvailableCatalogs[];
    }

    return [];
  };

  const generateReMLDLink = (brand: string) =>
    `https://minhaloja.${domains[brand]}/redirect/${resellerId}/?origin=${config.app.slugname}`;

  return {
    components,
    filterCurrentCycleGuides: filterCurrentCycleGuides(),
    generateReMLDLink,
  };
}
